export type Click = "Click";
export type Drag  = "Drag";
export type Press = "Press";
export type Release = "Release";

export type InputActionType = Click | Drag | Press | Release;

/*
matcher: export type \w+ = "\w+";
replace: static readonly $1:$1 = "$2"; 
*/
export class InputActionTypes
{
  static readonly Click:Click = "Click"; 
  static readonly Drag:Drag = "Drag"; 
  static readonly Press:Press = "Press"; 
  static readonly Release:Release = "Release"; 
}